import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track, captureAttribution } from "../lib/analytics";

let lastKey = null;

/* One virtual_page_view per client-side navigation (not the first load: GTM records that), sent after usePageMeta has set the new title (or 1.5s at most). */
export function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    const key = `${location.key}|${location.pathname}${location.search}`;
    if (key === lastKey) return undefined;
    if (lastKey === null) { lastKey = key; return undefined; }
    let sent = false;
    let timer;
    const send = () => {
      if (sent || key === lastKey) return;
      sent = true;
      lastKey = key;
      captureAttribution(location.search);
      track("virtual_page_view", { page_path: location.pathname + location.search, page_location: window.location.href, page_title: document.title });
    };
    const onMeta = () => { clearTimeout(timer); timer = setTimeout(send, 50); };
    window.addEventListener("stl:pagemeta", onMeta);
    const fallback = setTimeout(send, 1500);
    return () => { window.removeEventListener("stl:pagemeta", onMeta); clearTimeout(timer); clearTimeout(fallback); };
  }, [location.key, location.pathname, location.search]);
  return null;
}
